// extracted by mini-css-extract-plugin
export default {"button":"style_button__1UEiO","subTitle":"style_subTitle__+2DNg","tags":"style_tags__5e2IA"};